import React from "react";
import styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../../ui/Input/Input";
import TextArea from "../../../ui/TextArea/TextArea";
import { setUpdateAssistant } from "../../../store/slices/assistantSlice";
import { Toggls } from "./Toggls";
import { Files } from "./Files";

export const Card = () => {
  const dispatch = useDispatch();

  const activeAssistant = useSelector(
    (state) => state.assistant.activeAssistant
  );
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const handlerSystemInstruction = (e) => {
    if (updateAssistant) {
      const updAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          instruction: e.target.value,
        },
      };

      dispatch(setUpdateAssistant(updAssistant));
    }
  };

  const handlerNameAssistant = (e) => {
    if (updateAssistant) {
      const updAssistant = {
        ...updateAssistant,
        name: e.target.value,
      };
      dispatch(setUpdateAssistant(updAssistant));
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardContainer}>
        <Input
          label={"Название"}
          value={
            updateAssistant
              ? updateAssistant.name
              : activeAssistant
              ? activeAssistant.name
              : "Имя ассистента"
          }
          onChange={handlerNameAssistant}
          readOnly={activeAssistant && !updateAssistant}
        />
        <TextArea
          label={"Инструкция"}
          rows="20"
          value={
            updateAssistant
              ? updateAssistant.settings.instruction
              : activeAssistant
              ? activeAssistant.settings.instruction
              : "Ты полезный помощник"
          }
          enterSend={false}
          onChange={handlerSystemInstruction}
          readOnly={activeAssistant && !updateAssistant}
        />
      </div>
      <Toggls />
      <Files />
    </div>
  );
};
